export default __webpack_public_path__ + "static/6-840cd52d588c6f12f05f93593347ecd3.jpg";